import { Injectable } from '@angular/core';
import { Subject, Subscription } from 'rxjs';

import { ProtoReturnValue } from 'src/app/@core/types';

@Injectable({
  providedIn: 'root',
})
export class Events {
  private channels: { [key: string]: Subject<ProtoReturnValue> } = {};

  public subscribe(topic: string, observer: (_: ProtoReturnValue) => void): Subscription {
    if (!this.channels[topic]) {
      this.channels[topic] = new Subject<ProtoReturnValue>();
    }

    return this.channels[topic].subscribe(observer);
  }

  public publish(topic: string, data: ProtoReturnValue): void {
    if (!this.channels[topic]) { return; }

    this.channels[topic].next(data);
  }

  public unsubscribe(topic: string): void {
    if (!this.channels[topic]) {
      return;
    }

    this.channels[topic].complete();

    delete this.channels[topic];
  }
}
